export const applyValues = function (
    endpoint: string,
    data: { [key: string]: string | number | boolean }
): string {
    return endpoint.replace(/\{([^\\}]+)?\}/g, function (match, name) {
        return `${data[name] ?? match}`;
    });
};
